import { extendTheme } from "@chakra-ui/react";

// Site-ul a fost construit cu Semantic UI, Bootstrap și MDB încărcate global.
// Acestea au fost eliminate (~180 KB de CSS); regulile de mai jos reproduc
// exact stilurile pe care le dădeau elementelor de bază, ca aspectul să rămână același.
const headingFont = "Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif";

const theme = extendTheme({
  styles: {
    global: {
      // Semantic UI: baza pentru toate valorile rem din Chakra (1rem = 14px)
      html: {
        fontSize: "14px",
      },
      body: {
        fontSize: "14px",
        overflowX: "hidden",
      },

      // Bootstrap: imaginile și iconițele aliniate pe mijlocul rândului
      "img, svg": {
        verticalAlign: "middle",
      },

      // Semantic UI: titlurile fără stil Chakra (ex. pagina 404, titlurile din Blog)
      "h1, h2, h3, h4, h5": {
        fontFamily: headingFont,
        lineHeight: "1.28571429em",
      },
      h1: {
        minHeight: "1rem",
      },
      "h1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child":
        {
          marginTop: 0,
        },
      "h1:last-child, h2:last-child, h3:last-child, h4:last-child, h5:last-child":
        {
          marginBottom: 0,
        },

      // Semantic UI: paragrafe
      p: {
        lineHeight: "1.4285em",
      },
      "p:first-child": {
        marginTop: 0,
      },
      "p:last-child": {
        marginBottom: 0,
      },

      // Bootstrap: liniile de separare au 1px plin în culoarea textului (+ bordura Chakra)
      hr: {
        color: "inherit",
        backgroundColor: "currentColor",
      },
      "hr:not([size])": {
        height: "1px",
      },

      // Semantic UI: link-urile simple devin albastre la hover
      "a:hover": {
        color: "#1e70bf",
      },

      // Bootstrap: fără contur la click pe butoane (rămâne la navigarea cu tastatura)
      "button:focus:not(:focus-visible)": {
        outline: 0,
      },

      // Semantic UI: culoarea textului selectat
      "::selection": {
        backgroundColor: "#cce2ff",
        color: "rgba(0, 0, 0, 0.87)",
      },
      "input::selection, textarea::selection": {
        backgroundColor: "hsla(0, 0%, 39%, 0.4)",
        color: "rgba(0, 0, 0, 0.87)",
      },

      // Semantic UI: barele de derulare din interiorul paginii
      "body ::-webkit-scrollbar": {
        WebkitAppearance: "none",
        height: "10px",
        width: "10px",
      },
      "body ::-webkit-scrollbar-track": {
        background: "rgba(0, 0, 0, 0.1)",
        borderRadius: 0,
      },
      "body ::-webkit-scrollbar-thumb": {
        background: "rgba(0, 0, 0, 0.25)",
        borderRadius: "5px",
        cursor: "pointer",
        transition: "color 0.2s ease",
      },
      "body ::-webkit-scrollbar-thumb:window-inactive": {
        background: "rgba(0, 0, 0, 0.15)",
      },
      "body ::-webkit-scrollbar-thumb:hover": {
        background: "hsla(202, 5%, 52%, 0.8)",
      },
    },
  },
});

export default theme;
